export default "__VITE_ASSET__BOeeE66S__"